import { BreadcrumbsForFooter } from "@/components/Breadcrumbs";
import Copyrights from "@/components/Copyrights";
import config from "@/lib/config";
import {
  companyLink,
  helpLink,
  maintenanceLink,
  privacyLink,
} from "@/lib/constants";
import styles from "@/styles/Footer.module.scss";
import classnames from "classnames";
import { useRouter } from "next/router";
import { useMemo } from "react";
import XLogo from "../svgs/x_logo_footer.svg";

function FooterLink(props) {
  const { wrapperClass, linkClass, children, ...linkProps } = props;
  return (
    <li className={classnames(styles.wrapper, wrapperClass)}>
      <a className={classnames(styles.link)} {...linkProps}>
        {children}
      </a>
    </li>
  );
}

function FooterUpper({ isLoginPage }) {
  if (isLoginPage) return null;
  const help = useMemo(() => helpLink(), []);
  const maintenance = useMemo(() => maintenanceLink(), []);
  return (
    <div className={`${styles.box} ${styles.upper}`}>
      <ul className={styles.links}>
        <FooterLink href={help} target="_blank" rel="noopener noreferrer">
          ヘルプ
        </FooterLink>
        <FooterLink href="/static/feature/constant/environment">
          動作環境
        </FooterLink>
        {/*<FooterLink href="/inquiry">お問い合わせ</FooterLink>*/}
        <FooterLink href={maintenance}>メンテナンス情報</FooterLink>

        <FooterLink
          wrapperClass={styles.twitter}
          linkClass={styles.twitter}
          href="https://x.com/SPOOX_enta"
          target="_blank"
          rel="noopener noreferrer"
        >
          <XLogo className={styles.Icon}></XLogo>
          SPOOX公式X（旧Twitter）
        </FooterLink>
      </ul>
    </div>
  );
}

function FooterLower({}) {
  const privacy = useMemo(() => privacyLink(), []);
  const year = new Date().getFullYear();
  const company = useMemo(() => companyLink(), []);

  return (
    <div className={`${styles.box} ${styles.lower}`}>
      <ul className={styles.links}>
        <FooterLink href={company} target="_blank" rel="noopener noreferrer">
          会社概要
        </FooterLink>
        <FooterLink href="/static/legal/service_term">SPOOX利用規約</FooterLink>

        <FooterLink href="/static/legal/valueplan_term">
          {config.valuePlan.text}（スカパー向け提携モデル）利用規約
        </FooterLink>

        <FooterLink href={privacy} target="_blank" rel="noopener noreferrer">
          プライバシーポリシー
        </FooterLink>
        <FooterLink href="/static/legal/sct_law">
          特定商取引法に基づく表記（返品特約含む）
        </FooterLink>
        <FooterLink href="/static/legal/site_policy">サイトポリシー</FooterLink>
      </ul>

      <p className={styles.copyright}>
        COPYRIGHT © 2011-{year} SKY PERFECT JSAT CORPORATION ALL RIGHTS
        RESERVED.
      </p>

      <Copyrights />
    </div>
  );
}

function Footer() {
  const router = useRouter();
  const isLoginPage = (() => {
    return router.pathname == "/login";
  })();

  return (
    <footer className={styles.footer} role="contentinfo">
      <BreadcrumbsForFooter />
      <FooterUpper {...{ isLoginPage }} />
      <FooterLower {...{}} />
    </footer>
  );
}

export default Footer;
